import { motion } from 'framer-motion';
import React,{useState} from 'react'

const ErrorMessage = ({ error,message,classKey }) => {
    return (
        <motion.p
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
            className={classKey?classKey:"text-sm font-normal text-[#F04438] mt-2"}
        >
            {error && message}
        </motion.p>
    );
};
export default ErrorMessage;
